module.exports = __webpack_public_path__ + "static/img/how-to-align_en.5f6d8095.gif";